import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
    return (
        <input
            type={type}
            data-slot="input"
            className={cn(
                "file:text-foreground placeholder:text-muted-foreground selection:bg-corporate-blue-600 selection:text-white dark:bg-input/30 border-corporate-gray-300 flex h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
                "focus-visible:border-corporate-blue-500 focus-visible:ring-corporate-blue-200 focus-visible:ring-[3px]",
                "aria-invalid:ring-red-200 aria-invalid:border-red-500",
                className
            )}
            {...props}
        />
    )
}

export { Input }
